import { FC } from 'react';
import strings from '../../../../common/Translation/Translate';
import axiosInstance from '../../../../utils/axios';
import { URLS } from '../../../../utils/constants/urls';
import { createDropdownData } from '../../../../utils/validators/HelperFunctions';
import IdsMappingList, { IdsMappingListConfig } from '../shared/IdsMappingList';
import { optionLabel, optionValue } from '../shared/idsMappingTableCells';
import { AddEditLayoutMappingsForm } from './AddEditLayoutMappings/AddEditLayoutMappingsForm';

const layoutMappingConfig: IdsMappingListConfig = {
  kind: 'layout',
  title: 'Layout Mappings',
  subtitle: 'Map BBR layouts to IDS layout names and codes.',
  addButtonText: 'Add Layout Mapping',
  addDrawerTitle: 'Add Layout Mapping',
  editDrawerTitle: 'Edit Layout Mapping',
  searchPlaceholder: 'Search by IDS name or code',
  entityLabel: 'Layout mappings',
  listApi: URLS.layoutMappings,
  addApi: URLS.addLayoutMapping,
  getById: URLS.getLayoutMappingById,
  saveApi: URLS.editLayoutMapping,
  deleteApi: URLS.deleteLayoutMapping,
  importApi: URLS.importLayoutMappings,
  downloadImportTemplate: URLS.downloadLayoutMappingsTemplate,
  bbrHeader: 'BBR Layout',
  idsHeader: 'IDS Layout',
  idsSortField: 'layoutName',
  getBbrLabel: row => optionLabel(row.layout) || '—',
  getIdsName: row => row.layoutName,
  getIdsCode: row => row.layoutCode,
  formModel: options => AddEditLayoutMappingsForm(strings, options),
  emptyFormValues: { layout: '', layoutName: '', layoutCode: '' },
  loadDropdownOptions: async () => {
    const { data, status } = await axiosInstance.get(URLS.layouts);
    if (status === 200 && data?.length > 0) {
      return createDropdownData(data, ['id', 'name']);
    }
    return [];
  },
  mapResponseToForm: data => ({
    layout: data.layout || '',
    layoutName: data.layoutName || '',
    layoutCode: data.layoutCode || '',
  }),
  mapFormToPayload: body => ({
    layoutId: optionValue(body.layout),
    layoutName: body.layoutName,
    layoutCode: body.layoutCode,
  }),
  getDeleteEntityName: values => optionLabel(values.layout) || String(values.layoutName || ''),
};

const LayoutMappingsList: FC = () => <IdsMappingList config={layoutMappingConfig} />;

export default LayoutMappingsList;
